<template>
  <div class="disclaimer">
    <div>{{ t('免责声明：以上内容仅供参考，不作为投资依据') }}</div>
    <div>{{ t('投资有风险，入市需谨慎') }}</div>
  </div>
</template>

<script>
import { i18nTranslateInit } from '@/utils/utility-lang'
export default {
  data() {
    return {
      t: i18nTranslateInit.t
    }
  }
}
</script>

<style lang="scss" scoped>
.disclaimer {
  line-height: 20px;
  padding: 20px 15px;
  text-align: center;
  font-size: 11px;
  color: var(--font-color-7);
}
</style>
